export const normalizeCourtDisplayName = (value) =>
  String(value || '').trim().replace(/\s+/g, ' ');

export const getCourtNumber = (courtId) => String(courtId || '').split('-')[1] || '';

export const getCourtDisplayNameFromCourt = (court, fallbackPrefix = 'Court') => {
  const displayName = normalizeCourtDisplayName(court?.displayName);
  if (displayName) return displayName;
  if (!fallbackPrefix) return '';
  const number = getCourtNumber(court?.court);
  return `${fallbackPrefix} ${number}`.trim();
};

export const getCourtDisplayNameById = (courtId, courts = [], fallbackPrefix = 'Court') => {
  const court = (Array.isArray(courts) ? courts : []).find((item) => item?.court === courtId);
  if (court) {
    return getCourtDisplayNameFromCourt(court, fallbackPrefix);
  }
  if (!fallbackPrefix) return '';
  const number = getCourtNumber(courtId);
  return `${fallbackPrefix} ${number}`.trim();
};
